export default "__VITE_PUBLIC_ASSET__05816d8b__"